import {SchoolData} from 'stores/AdminGeneralStore';
import ApiManager, {RequestType} from '../ApiManager';
import {
  CreateGroupData,
  GroupInfoResponse,
  GroupsResponse,
  StudentData,
  UpdateGroupData,
} from './AdminApiModels';

export interface IAdminApiManager {
  getGroups: () => Promise<GroupsResponse[]>;
  getGroupById: (groupId: string) => Promise<GroupInfoResponse>;
  createGroup: (body: CreateGroupData) => Promise<void>;
  updateGroup: (body: UpdateGroupData) => Promise<void>;
  deleteGroup: (groupId: string) => Promise<void>;
  getTenant: () => Promise<SchoolData>;
  updateTenant: (body: SchoolData) => Promise<void>;
  getTeachers: () => Promise<StudentData[]>;
  updateTeachers: (body: StudentData[]) => void;
}

export default class AdminApiManager implements IAdminApiManager {
  getGroups = () => {
    return ApiManager.request<GroupsResponse[]>(RequestType.getGroups, {});
  };

  getGroupById = (groupId: string) => {
    return ApiManager.request<GroupInfoResponse>(RequestType.getGroupInfo, {
      query: groupId,
    });
  };

  createGroup = (body: CreateGroupData) => {
    return ApiManager.request<void>(RequestType.createGroup, {body: body});
  };

  updateGroup = (body: UpdateGroupData) => {
    return ApiManager.request<void>(RequestType.updateGroup, {body: body});
  };

  deleteGroup = (groupId: string) => {
    return ApiManager.request<void>(RequestType.deleteGroup, {
      query: groupId,
    });
  };

  getTenant = () => {
    return ApiManager.request<SchoolData>(RequestType.getTenant, {});
  };

  updateTenant = (body: SchoolData) => {
    return ApiManager.request<void>(RequestType.updateTenant, {body: body});
  };

  getTeachers = () => {
    return ApiManager.request<StudentData[]>(RequestType.getTeachers, {});
  };

  updateTeachers = (body: StudentData[]) => {
    return ApiManager.request<void>(RequestType.updateTeachers, {body: body});
  };
}
